/* ==========================================================================
   Sitaara by Sama — Global Theme JS
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Sticky header: transparent on hero, solid on scroll ---------- */
  var header = document.querySelector('[data-site-header]');
  if (header) {
    var toggleHeader = function () {
      header.classList.toggle('is-solid', window.scrollY > 60);
    };
    toggleHeader();
    window.addEventListener('scroll', toggleHeader, { passive: true });
  }

  /* ---------- Scroll reveal ---------- */
  var revealEls = document.querySelectorAll('.st-reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    window.__stRevealObserver = io;
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('in'); });
  }

  /* ---------- Plate skeleton removal once an image finishes loading ---------- */
  document.querySelectorAll('.st-plate[data-loading="true"] img').forEach(function (img) {
    var clear = function () { img.closest('.st-plate').removeAttribute('data-loading'); };
    if (img.complete) { clear(); } else { img.addEventListener('load', clear); }
  });

  /* ---------- Prism Collection: crystal-refraction swatch interaction ----------
     Each swatch carries data-swatch-color-1 / data-swatch-color-2.
     Clicking re-tints every product plate within the same section as a soft
     refracted-light transition — the section's signature interaction. */
  document.querySelectorAll('[data-prism-section]').forEach(function (section) {
    var swatches = section.querySelectorAll('[data-prism-swatch]');
    var plates = section.querySelectorAll('[data-prism-plate]');

    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        swatches.forEach(function (s) { s.classList.remove('is-active'); });
        swatch.classList.add('is-active');

        var c1 = swatch.getAttribute('data-swatch-color-1');
        var c2 = swatch.getAttribute('data-swatch-color-2');
        if (!c1 || !c2) return;

        plates.forEach(function (plate, i) {
          plate.style.transition = 'filter .8s ease';
          plate.style.filter = 'brightness(0.4) saturate(0)';
          window.setTimeout(function () {
            var overlay = plate.querySelector('[data-prism-tint]');
            if (overlay) {
              overlay.style.background = 'linear-gradient(150deg, ' + c1 + ', ' + c2 + ')';
            }
            plate.style.filter = 'brightness(1) saturate(1)';
          }, 220 + i * 90);
        });
      });
    });
  });

  /* ---------- Full-screen mobile nav ---------- */
  var navToggles = document.querySelectorAll('[data-nav-toggle]');
  var navPanel = document.querySelector('[data-nav-panel]');
  if (navToggles.length && navPanel) {
    navToggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var isOpen = navPanel.classList.toggle('is-open');
        navToggles.forEach(function (b) { b.setAttribute('aria-expanded', isOpen ? 'true' : 'false'); });
        document.body.classList.toggle('st-nav-locked', isOpen);
      });
    });
    navPanel.querySelectorAll('[data-mobile-parent-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.st-mobile-item');
        var sub = item.querySelector('.st-mobile-sub');
        var isOpen = sub.classList.toggle('is-open');
        item.classList.toggle('is-open', isOpen);
      });
    });
  }

  /* ---------- Predictive search open/close ---------- */
  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchPanel = document.querySelector('[data-search-panel]');
  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', function () {
      var isOpen = searchPanel.classList.toggle('is-open');
      if (isOpen) {
        var input = searchPanel.querySelector('input[type="search"]');
        if (input) input.focus();
      }
    });
  }

  /* ---------- Wishlist (lightweight, localStorage-backed) ---------- */
  var WISHLIST_KEY = 'sitaara:wishlist';
  function getWishlist() {
    try { return JSON.parse(window.localStorage.getItem(WISHLIST_KEY)) || []; }
    catch (e) { return []; }
  }
  function setWishlist(ids) {
    try { window.localStorage.setItem(WISHLIST_KEY, JSON.stringify(ids)); } catch (e) {}
  }
  function paintWishlistButtons() {
    var ids = getWishlist();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var id = btn.getAttribute('data-product-id');
      btn.setAttribute('aria-pressed', ids.indexOf(id) > -1 ? 'true' : 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-product-id');
    var ids = getWishlist();
    var i = ids.indexOf(id);
    if (i > -1) { ids.splice(i, 1); } else { ids.push(id); }
    setWishlist(ids);
    paintWishlistButtons();
  });
  paintWishlistButtons();

  /* ---------- Quick view modal ---------- */
  var qvOverlay = document.querySelector('[data-quick-view-overlay]');
  var qvModal = document.querySelector('[data-quick-view-modal]');
  function closeQuickView() {
    if (qvOverlay) qvOverlay.classList.remove('is-open');
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-quick-view-close]') || e.target === qvOverlay) closeQuickView();

    var trigger = e.target.closest('[data-quick-view-trigger]');
    if (!trigger || !qvOverlay || !qvModal) return;
    e.preventDefault();
    var handle = trigger.getAttribute('data-product-handle');
    qvOverlay.classList.add('is-open');
    qvModal.innerHTML = '<button type="button" class="st-qv-close" data-quick-view-close aria-label="Close">&times;</button><div class="st-qv-loading">Loading&hellip;</div>';

    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var img = p.featured_image ? p.featured_image : (p.images[0] || '');
        var price = (p.price / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR' });
        qvModal.innerHTML =
          '<button type="button" class="st-qv-close" data-quick-view-close aria-label="Close">&times;</button>' +
          '<div class="st-qv-media"><img src="' + img + '" alt="' + p.title + '"></div>' +
          '<div class="st-qv-body">' +
            '<h3>' + p.title + '</h3>' +
            '<span class="st-price">' + price + '</span>' +
            '<p style="font-size:14px;line-height:1.7;color:#54504A;margin-bottom:22px;">' + (p.description ? p.description.replace(/<[^>]*>/g, '').slice(0, 160) : '') + '&hellip;</p>' +
            '<a class="st-btn st-btn-dark" href="' + p.url + '" style="border:1px solid var(--color-charcoal);">View Full Details</a>' +
          '</div>';
      })
      .catch(function () {
        qvModal.innerHTML = '<button type="button" class="st-qv-close" data-quick-view-close aria-label="Close">&times;</button><div class="st-qv-loading">Could not load this piece. Please try again.</div>';
      });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeQuickView(); });

  /* ---------- Recently viewed ---------- */
  var RECENT_KEY = 'sitaara:recently-viewed';
  var currentHandle = document.body.getAttribute('data-product-handle');
  if (currentHandle) {
    try {
      var seen = JSON.parse(window.localStorage.getItem(RECENT_KEY)) || [];
      seen = seen.filter(function (h) { return h !== currentHandle; });
      seen.unshift(currentHandle);
      seen = seen.slice(0, 8);
      window.localStorage.setItem(RECENT_KEY, JSON.stringify(seen));
    } catch (e) {}
  }
  var recentContainer = document.querySelector('[data-recently-viewed]');
  if (recentContainer) {
    var handles = [];
    try { handles = (JSON.parse(window.localStorage.getItem(RECENT_KEY)) || []).filter(function (h) { return h !== currentHandle; }).slice(0, 4); }
    catch (e) {}
    if (handles.length) {
      recentContainer.closest('[data-recently-viewed-section]').style.display = '';
      Promise.all(handles.map(function (h) { return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }))
        .then(function (products) {
          recentContainer.innerHTML = products.filter(Boolean).map(function (p) {
            var img = p.featured_image || (p.images[0] || '');
            var price = (p.price / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR' });
            return '<a href="' + p.url + '" class="st-pcard-simple">' +
                     '<div class="st-plate st-grain" style="aspect-ratio:3/4;"><img src="' + img + '" alt="' + p.title + '" loading="lazy" style="width:100%;height:100%;object-fit:cover;position:absolute;inset:0;"></div>' +
                     '<span class="st-name">' + p.title + '</span><span class="st-price">' + price + '</span>' +
                   '</a>';
          }).join('');
        });
    }
  }

  /* ---------- Product gallery: thumbnail switching + click-to-zoom ---------- */
  var gallery = document.querySelector('[data-product-gallery]');
  if (gallery) {
    var mainImg = gallery.querySelector('[data-gallery-main] img');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (mainImg) mainImg.src = thumb.getAttribute('data-full-src');
      });
    });
    var mainWrap = gallery.querySelector('[data-gallery-main]');
    if (mainWrap && mainImg) {
      mainWrap.addEventListener('mousemove', function (e) {
        if (!mainWrap.classList.contains('is-zoomed')) return;
        var rect = mainWrap.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top) / rect.height) * 100;
        mainImg.style.transformOrigin = x + '% ' + y + '%';
      });
      mainWrap.addEventListener('click', function () {
        mainWrap.classList.toggle('is-zoomed');
      });
    }
  }

  /* ---------- Product form: quantity stepper ---------- */
  document.querySelectorAll('[data-qty-minus], [data-qty-plus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('input[name="quantity"]');
      if (!input) return;
      var val = parseInt(input.value, 10) || 1;
      val = btn.hasAttribute('data-qty-plus') ? val + 1 : Math.max(1, val - 1);
      input.value = val;
    });
  });

  /* ---------- Product form: variant matching from option selects ---------- */
  var variantsScript = document.querySelector('[data-product-variants-json]');
  var optionSelectors = document.querySelectorAll('[data-option-selector]');
  var variantIdInput = document.querySelector('[data-variant-id]');
  var priceRow = document.querySelector('.st-price-row');
  if (variantsScript && optionSelectors.length && variantIdInput) {
    var variants = [];
    try { variants = JSON.parse(variantsScript.textContent); } catch (e) {}

    var syncVariant = function () {
      var selected = Array.prototype.map.call(optionSelectors, function (s) { return s.value; });
      var match = variants.find(function (v) {
        var opts = [v.option1, v.option2, v.option3].filter(function (o) { return o !== null; });
        return opts.length === selected.length && opts.every(function (o, i) { return o === selected[i]; });
      });
      if (match) {
        variantIdInput.value = match.id;
        if (priceRow) {
          var price = (match.price / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR' });
          var first = priceRow.querySelector('span');
          if (first) first.textContent = price;
        }
      }
    };
    optionSelectors.forEach(function (s) { s.addEventListener('change', syncVariant); });
  }

  /* ---------- Cart page: quantity stepper + remove line ---------- */
  var cartForm = document.querySelector('.st-cart-form');
  if (cartForm) {
    cartForm.addEventListener('click', function (e) {
      var minus = e.target.closest('[data-cart-qty-minus]');
      var plus = e.target.closest('[data-cart-qty-plus]');
      var remove = e.target.closest('[data-cart-remove]');
      if (minus || plus) {
        var key = (minus || plus).getAttribute('data-key');
        var input = cartForm.querySelector('[data-cart-qty-input][data-key="' + key + '"]');
        if (input) {
          var val = parseInt(input.value, 10) || 0;
          input.value = plus ? val + 1 : Math.max(0, val - 1);
          cartForm.submit();
        }
      }
      if (remove) {
        var rKey = remove.getAttribute('data-key');
        var rInput = cartForm.querySelector('[data-cart-qty-input][data-key="' + rKey + '"]');
        if (rInput) {
          rInput.value = 0;
          cartForm.submit();
        }
      }
    });
  }

  /* ---------- Collection filter panel ---------- */
  var filterToggle = document.querySelector('[data-filter-toggle]');
  var filterPanel = document.querySelector('[data-filter-panel]');
  if (filterToggle && filterPanel) {
    filterToggle.addEventListener('click', function () {
      filterPanel.classList.toggle('is-open');
    });
  }
  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }
});
